import { PlayerPosition } from '@Apollo/types';

/**
 * Team size enum - определяет количество игроков в команде
 */
export enum TeamSize {
  STANDARD = 5, // 4+1 (стандартная схема)
  EXTENDED = 8, // 7+1 (расширенная схема)
}

/**
 * Formation types - упрощенные типы для флексибльной архитектуры
 */
export enum FormationType {
  // 4+1 formations
  STANDARD_1_1_1_1_1 = '1-1-1-1-1',

  // 7+1 flexible formation (базовый тип, содержимое определяется динамически)
  EXTENDED_1_2_2_2_1 = '1-2-2-2-1',
}

/**
 * Position layout - информация о расположении позиции на поле
 */
export type PositionLayout = {
  position: PlayerPosition;
  index: number; // для множественных позиций одного типа (например, DEF1, DEF2)
  cssClass: string;
  key: string; // уникальный ключ для позиции, например "back-0", "back-1"
  coordinates?: { x: number; y: number };
};

/**
 * Formation schema - полная схема формации
 */
export type FormationSchema = {
  type: FormationType;
  teamSize: TeamSize;
  positions: {
    [PlayerPosition.Goalkeeper]: number;
    [PlayerPosition.Back]: number;
    [PlayerPosition.Midfield]: number;
    [PlayerPosition.Forward]: number;
    [PlayerPosition.Reserve]: number;
  };
  layout: PositionLayout[];
};

/**
 * Validation error types
 */
export type ValidationError = {
  type: 'MISSING_PLAYERS' | 'TOO_MANY_PLAYERS' | 'INVALID_FORMATION';
  position?: PlayerPosition;
  required?: number;
  actual?: number;
  message?: string;
};

/**
 * Validation warning types
 */
export type ValidationWarning = {
  type: 'INCOMPLETE_FORMATION' | 'POSITION_SUBOPTIMAL' | 'CAPTAIN_MISSING';
  position?: PlayerPosition;
  message?: string;
};

/**
 * Validation result
 */
export type ValidationResult = {
  valid: boolean;
  errors: ValidationError[];
  warnings: ValidationWarning[];
};

/**
 * Position availability map - карта доступности позиций
 */
export type PositionAvailabilityMap = {
  available: PlayerPosition[];
  disabled: PlayerPosition[];
  shouldDisableKey: (positionKey: string) => boolean; // Новая функция для проверки конкретного ключа
  getAvailableSlots: (position: PlayerPosition) => number;
  getFilledSlots: (position: PlayerPosition) => number;
};
